/* AJTV — Add-to-Cart redirect guardrail (DO NOT PUBLISH WITHOUT MARIO'S APPROVAL)
   Shopify location: assets/ajtv-redirect.js
   Load it ONLY in the duplicate/unpublished theme, e.g. in layout/theme.liquid
   just before </body>:
     <script src="{{ 'ajtv-redirect.js' | asset_url }}" defer></script>
   Why this file exists: Horizon's sticky bar + collection Quick Add are theme
   web-components (sticky-add-to-cart, quick-add forms posting to /cart/add).
   The Liquid button (buy-button-redirect.liquid) is the primary fix; this JS
   is the belt-and-braces net for sticky / quick-add / any missed form.
   Same-tab redirect (location.assign) is deliberate — see liquid file notes. */
(function () {
  var FALLBACK = 'https://TheAlexJonesStore.com/AJTV';

  function affiliateUrl(fromEl) {
    var host = fromEl && fromEl.closest ? fromEl.closest('[data-ajtv-affiliate-url]') : null;
    var btn = document.querySelector('.ajtv-affiliate-button[data-ajtv-affiliate-url]');
    return (host && host.getAttribute('data-ajtv-affiliate-url')) ||
           (btn && btn.getAttribute('data-ajtv-affiliate-url')) || FALLBACK;
  }

  function hideCheckoutBits(root) {
    (root || document).querySelectorAll(
      'shopify-accelerated-checkout, .shopify-payment-button, [data-shopify="payment-button"]'
    ).forEach(function (el) { el.style.setProperty('display', 'none', 'important'); });
    // Relabel Horizon sticky bar so it does not promise an on-site cart
    document.querySelectorAll('.sticky-add-to-cart__button .add-to-cart-text__content > span:first-child')
      .forEach(function (el) { if (el.textContent.trim() === 'Add to cart') el.textContent = 'Buy at The Alex Jones Store'; });
  }

  // Capture phase: runs before Horizon component handlers (on:click) and form submit.
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest(
      '.add-to-cart-button, button[name="add"], .quick-add__button, .sticky-add-to-cart__button, .shopify-payment-button__button'
    );
    if (!t) return;
    e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    window.location.assign(affiliateUrl(t));
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    var action = (f.getAttribute && f.getAttribute('action')) || '';
    if (action.indexOf('/cart/add') !== -1 || f.getAttribute('data-type') === 'add-to-cart-form') {
      e.preventDefault(); e.stopPropagation();
      window.location.assign(affiliateUrl(f));
    }
  }, true);

  hideCheckoutBits(document);
  new MutationObserver(function () { hideCheckoutBits(document); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
